export default __webpack_public_path__ + "static/media/Pot3.0e86e26f.svg";